import React, { FC, PropsWithChildren } from 'react';

import BooleanTooltip from './BooleanTooltip';
import TextOverflowTooltip from './TextOverflowTooltip';

export interface ConditionalTooltipProps {
  condition: boolean;
  text: string;
}

/**
 * Prefer using MUI's `Tooltip` directly instead
 * @deprecated
 */
const ConditionalTooltip: FC<PropsWithChildren<ConditionalTooltipProps>> = ({
  children,
  condition,
  text,
  ...props
}) => {
  return text ? (
    <TextOverflowTooltip text={text} {...props}>
      {children}
    </TextOverflowTooltip>
  ) : (
    <BooleanTooltip condition={condition} {...props}>
      {children}
    </BooleanTooltip>
  );
};

export default ConditionalTooltip;
